import { render, staticRenderFns } from "./other-earnings-charges-table.vue?vue&type=template&id=080c7f29"
import script from "./other-earnings-charges-table.vue?vue&type=script&lang=js"
export * from "./other-earnings-charges-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports